<template>
  <section>
    <div
      v-if="verificationFailed"
      class="fail-message-style mb-4"
    >
      <p class="fail-style">
        <v-icon
          color="#C62828"
          size="30"
        >
          mdi-alert
        </v-icon> <br>
        {{ verificationFailedMessage }}
      </p>
    </div>
    <v-card
      elevation="1"
      color="#FFF"
    >
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-card-title>
          <p class="process-header">
            Select Your Contract
          </p>
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="selectedContract"
            :items="projectContracts"
            item-value="id"
            class="field-text-style"
            color="#37474F"
            filled
            outlined
            dense
            light
            item-text="name"
            :rules="[(v) => !!v || 'This field is required']"
            label="Select a Contract*"
            prepend-inner-icon="mdi-file-document-multiple"
            persistent-hint
            @input="getSelectedContractDetails()"
          />
          <div v-if="isContractSelected">
            <p class="title-text-style">
              Description: <font
                v-if="selectedContractDetails.details.description !== null"
                class="value-text-style"
              >
                {{ selectedContractDetails.details.description }}
              </font><font
                v-else
                class="value-text-style"
              >
                N/A
              </font>
            </p>
            <p class="title-text-style">
              Contract Items: <font
                class="value-text-style"
              >
                {{ selectedContractDetails.details.budget_items.length }} Nos.
              </font><br>
              <font
                v-for="(item, i) in selectedContractDetails.details.budget_items"
                :key="i"
              >
                <span class="budget-style"> {{ item.name }} </span> |
              </font>
            </p>
            <p class="title-text-style">
              Status:- <font
                v-if="selectedContractDetails.status !== null"
                class="status-format"
                :color="getStatusColor(selectedContractDetails.details.status)"
              >
                {{ selectedContractDetails.details.status | statusFormat }}
              </font>
              <font
                v-else
                class="value-text-style"
              >
                N/A
              </font>
            </p>
            <br>
          </div>
        </v-card-text>
      </v-form>
    </v-card>
    <v-btn
      color="#000"
      class="mt-5 btn-style"
      elevation="0"
      @click="verifyContractDetails()"
    >
      Next
    </v-btn>
    <v-btn
      light
      color="#E6E6E6"
      class="mt-3 btn-style"
      elevation="0"
      @click="cancel()"
    >
      Cancel
    </v-btn>
    <centre-spinner
      :loading="loading"
    />
  </section>
</template>

  <script>
  import spinner from 'src/views/components/SpinnerCentre';
  import Constants from 'src/constants';

  export default {
    name: 'GatherContractDetails',
    components: {
      'centre-spinner': spinner,
    },
    filters: {
      statusFormat (val) {
        if (val === 'active') {
          return 'Active*';
        } else if (val === 'pending') {
          return 'Pending';
        } else if (val === 'completed') {
          return 'Completed*';
        } else {
          return val;
        }
      },
    },
    data: () => ({
      loading: false,
      valid: false,
      selectedContract: '',
      verificationFailed: false,
      verificationFailedMessage: '',
    }),
    computed: {
      userDetails () {
        return this.$store.getters.getUser;
      },
      locationName () {
        return this.$store.getters['swiftuser/getLocationName'];
      },
      projectContracts () {
        return this.$store.getters['projects/getProjectContracts'];
      },
      selectedContractDetails () {
        return this.$store.getters['swiftuser/getSelectedContractDetails'];
      },
      isContractSelected () {
        if (Object.keys(this.selectedContractDetails).length > 0) {
          return true;
        }
        return false;
      },
      selectedOrganization () {
        return this.$store.getters['organization/getSelectedOrganization'];
      },
    },
    mounted () {
      this.fetchProjectContracts();
    },
    methods: {
      async fetchProjectContracts () {
        this.loading = true;
        this.$store.dispatch('swiftuser/clearSavedContractDetails');
        await this.$store.dispatch('projects/fetchProjectContracts', {
          projectId: this.locationName.project.id,
        });
        this.loading = false;
      },
      async getSelectedContractDetails () {
        this.loading = true;
        this.$store.dispatch('swiftuser/clearSavedContractDetails');
        const contractDetails = this.projectContracts.find(
          contract => contract.id === this.selectedContract,
        );
        await this.$store.dispatch('swiftuser/saveSelectedContractDetails', {
          details: contractDetails,
        });
        this.loading = false;
      },
      async verifyContractDetails () {
        if (this.$refs.form.validate() === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please select the contract before proceeding to next step.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        this.loading = true;
        await this.$store.dispatch('swiftuser/verifyContractDetails', {
          organizationExtId: this.selectedOrganization.organization.external_id,
          contractId: {
            contract_id: this.selectedContract,
          },
        }).then(response => {
          this.loading = false;
          this.$emit('contract-details-stored');
        }).catch(error => {
          this.loading = false;
          this.verificationFailed = true;
          this.verificationFailedMessage = error.response.data.message;
        });
      },
      cancel () {
        this.loading = true;
        localStorage.removeItem('siteId');
        localStorage.removeItem('scannedTime');
        setTimeout(() => {
          this.$router.push({ name: 'CheckIn' });
        }, 1000);
      },
      getStatusColor (val) {
        if (val === 'active') {
          return '#2E7D32';
        } else if (val === 'pending') {
          return '#C62828';
        } else if (val === 'completed') {
          return '#FF3700';
        } else {
          return '#EF6C00';
        }
      },
    },
  };
</script>
<style scoped>
.budget-style {
  color: #FF3700;
  font-weight: 600;
  font-family: 'Times New Roman', Times, serif;
  text-transform: capitalize;
}
.status-format {
  text-transform: capitalize;
}
.theme--dark.v-list{
  background-color: white!important;
}
.theme--dark >>> .v-list-item{
  color:#37474F!important;
}
</style>
